import request from '@/utils/request'

// 登录方法
export function login(data) {
  return request({
    url: '/api/admin/auth/login',
    method: 'post',
    data
  })
}

// 获取用户信息
export function getInfo() {
  return request({
    url: '/api/admin/auth/info',
    method: 'get'
  })
}

// 退出登录
export function logout() {
  return request({
    url: '/api/admin/auth/logout',
    method: 'post'
  })
}

// 获取验证码
export function getCaptcha(key) {
  return request({
    url: '/api/admin/auth/captcha',
    method: 'get',
    params: { key }
  })
}

export default {
  login,
  getInfo,
  logout,
  getCaptcha
} 